// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  height: 100vh;
  display: flex;
  position: relative;
  overflow: hidden;
  z-index: auto;
}
.dashboard-container .trial-warning-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(90deg, #ff6b35, #f7941d);
  color: white;
  padding: 12px 20px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.dashboard-container .trial-warning-banner .trial-warning-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  max-width: 1200px;
  margin: 0 auto;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-icon {
  font-size: 16px;
  animation: pulse 2s infinite;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-text {
  font-weight: 500;
  font-size: 14px;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-upgrade-btn {
  background: white;
  color: #ff6b35;
  border: none;
  padding: 6px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-upgrade-btn:hover {
  background: #f0f0f0;
  transform: translateY(-1px);
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-close-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 50%;
  transition: background 0.3s ease;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
.dashboard-container .mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: none;
}
@media (max-width: 768px) {
  .dashboard-container .mobile-sidebar-overlay {
    display: block;
  }
}
.dashboard-container .dashboard-sidebar {
  width: 250px;
  background-color: #fff;
  border-right: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
  position: relative;
  z-index: 999;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section {
  margin-top: auto;
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, #eef1f8, #f7f9fc);
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  gap: 10px;
  text-align: center;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-heading {
  font-size: 0.9rem;
  font-weight: 500;
  color: #6b7280;
  letter-spacing: 0.5px;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-badge {
  background-color: #004A9A;
  color: white;
  font-size: 0.95rem;
  padding: 8px 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.3);
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-badge .plan-icon {
  font-size: 1.1rem;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-subtext {
  font-size: 0.8rem;
  color: #6b7280;
  max-width: 140px;
  line-height: 1.2;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .upgrade-button {
  background: #ff7e5f;
  background: linear-gradient(to right, #ff7e5f, #feb47b);
  border: none;
  padding: 8px 18px;
  font-size: 0.85rem;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  font-weight: 600;
}
.dashboard-container .dashboard-sidebar .ent-mode {
  background: transparent;
}
.dashboard-container .dashboard-sidebar .trial-countdown {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dashboard-container .dashboard-sidebar .trial-countdown.subscription-countdown {
  background: #f0f4ff;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-icon {
  display: flex;
  align-items: center;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info .trial-text {
  font-size: 11px;
  color: #666;
  font-weight: 500;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info .trial-days {
  font-size: 14px;
  font-weight: 700;
  color: #ff6b35;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info .trial-days.urgent {
  color: #d63031;
}
.dashboard-container .dashboard-sidebar .trial-countdown.subscription-countdown .trial-info .trial-days {
  color: #4f46e5;
}
.dashboard-container .dashboard-sidebar .trial-countdown.subscription-countdown .trial-info .trial-days.urgent {
  color: #d63031;
  animation: pulse 2s infinite;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 999;
    width: 0;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  }
  .dashboard-container .dashboard-sidebar.open {
    width: 250px !important;
  }
}
.dashboard-container .dashboard-sidebar .sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}
.dashboard-container .dashboard-sidebar .sidebar-header .close-sidebar-btn {
  background: none;
  border: none;
  color: #686868;
  cursor: pointer;
  font-size: 1.2rem;
  display: none;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-sidebar .sidebar-header .close-sidebar-btn {
    display: block;
  }
}
.dashboard-container .dashboard-sidebar .sidebar-header-closehead {
  padding: 0px !important;
}
.dashboard-container .dashboard-sidebar .dashboard-hidden-title {
  display: none;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab .tab-label-with-badge {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab .count-badge {
  background-color: crimson;
  color: #fff;
  font-size: 10px;
  padding: 5px;
  border-radius: 12px;
  width: 17px;
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab:hover, .dashboard-container .dashboard-sidebar .dashboard-sidebar-tab.active {
  background-color: #f4f7fe;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab .dashboard-tab-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab span {
  transition: opacity 0.2s;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab span:not(:empty) {
  opacity: 1;
}
.dashboard-container .dashboard-sidebar .lawsuitheadtxt {
  width: 90%;
  object-fit: contain;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) {
  width: 60px;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .dashboard-sidebar-tab {
  justify-content: center;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .dashboard-sidebar-tab span {
  display: none;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .dashboard-sidebar-tab .dashboard-tab-icon {
  margin-right: 0;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .sidebar-header {
  justify-content: center;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .sidebar-header .lawsuitheadtxt {
  display: none;
}
.dashboard-container .dashboard-main-area {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar {
  background-color: #e2e8f0;
  color: #262626;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-bottom: 2px solid #ddd;
  height: 46px;
  position: sticky;
  top: 0;
  z-index: 99;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 .hamburger {
  font-size: 1.2rem;
  background: none;
  border: none;
  color: #686868;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 .dashboard-activetabname {
  color: #262626;
  margin: 0;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
@media (min-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 .dashboard-activetabname {
    max-width: none;
  }
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons {
  display: flex;
  align-items: center;
  gap: 13px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon {
  position: relative;
  cursor: pointer;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon .dashboard-top-nav-icon-style {
  cursor: pointer;
  transition: transform 0.2s;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon .dashboard-top-nav-icon-style:hover {
  transform: scale(1.1);
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon .notification-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: crimson;
  color: white;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  z-index: 1;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  width: 150px;
  background-color: #fff;
  border-radius: 8px;
  z-index: 100;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .dashboard-profiletabs {
  display: block;
  text-align: left;
  width: 100%;
  padding: 10px 15px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .dashboard-profiletabs:hover {
  background-color: #f0f0f0;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .dashboard-profiletabs:not(:last-child) {
  border-bottom: 1px solid #eee;
}
.dashboard-container .dashboard-main-area .dashboard-content-area {
  flex: 1 1;
  padding: 15px;
  overflow-y: auto;
  background-color: #e2e8f0;
  height: calc(100vh - 46px);
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area {
    padding: 10px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .main-dashboard-content-area {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  height: 165px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area .main-dashboard-content-area {
    padding: 10px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs {
  background-color: white;
  margin-top: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs {
    margin-top: 10px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs .page-content-component {
  padding: 20px;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs .page-content-component {
    padding: 15px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabsone {
  margin-top: 0 !important;
}

@media (max-width: 768px) {
  .dashboard-container {
    flex-direction: column;
  }
  .dashboard-container .dashboard-sidebar {
    width: 0;
  }
  .dashboard-container .dashboard-sidebar.open {
    width: 250px !important;
  }
  .dashboard-container .dashboard-main-area {
    width: 100%;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .trial-warning-banner .trial-warning-content {
    flex-direction: column;
    gap: 8px;
    padding: 8px;
  }
  .trial-warning-banner .trial-warning-content .warning-text {
    font-size: 12px;
    text-align: center;
  }
  .trial-warning-banner .trial-warning-content .warning-upgrade-btn {
    font-size: 11px;
    padding: 5px 12px;
  }
  .sidebar-plan-section .trial-countdown {
    flex-direction: column;
    align-items: flex-start;
  }
  .sidebar-plan-section .trial-countdown .trial-info {
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AANF;AAQE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,oDAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AANN;AAQM;EACE,eAAA;EACA,4BAAA;AANR;AASM;EACE,gBAAA;EACA,eAAA;AAPR;AAUM;EACE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AARR;AAUQ;EACE,mBAAA;EACA,2BAAA;AARV;AAYM;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;AAVR;AAYQ;EACE,oCAAA;AAVV;AAgBE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;AAdJ;AAgBI;EAVF;IAWI,cAAA;EAbJ;AACF;AAgBE;EACE,YA7FY;EA8FZ,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;AAdJ;AAgBI;EACE,gBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,qDAAA;AAfN;AAoBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AAlBR;AAqBM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAnBR;AAsBM;EAIE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,8CAAA;AAvBR;AAyBQ;EACE,iBAAA;AAvBV;AA2BM;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAzBR;AA4BM;EACE,mBAAA;EACA,uDAAA;EAGA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,qDAAA;EACA,gBAAA;AA5BR;AAiCI;EACE,uBAAA;AA/BN;AAkCI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhCN;AAkCM;EACE,mBAAA;AAhCR;AAoCM;EACE,aAAA;EACA,mBAAA;AAlCR;AAqCM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAnCR;AAqCQ;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAnCV;AAsCQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AApCV;AAsCU;EACE,cAAA;AApCZ;AA0CM;EACE,cAAA;AAxCR;AA0CQ;EACE,cAAA;EACA,4BAAA;AAxCV;AAgDI;EAxIF;IAyII,eAAA;IACA,MAAA;IACA,OAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,wCAAA;EA7CJ;EAiDI;IACE,uBAAA;EA/CN;AACF;AAmDI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAjDN;AAmDM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAjDR;AAmDQ;EARF;IASI,cAAA;EAhDR;AACF;AAoDI;EACE,uBAAA;AAlDN;AAqDI;EACE,aAAA;AAnDN;AAsDI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AApDN;AAsDM;EACE,aAAA;EACA,mBAAA;EAGA,QAAA;AAtDR;AAyDM;EACE,yBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAvDR;AA2DM;EAEE,yBAAA;AA1DR;AA6DM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA3DR;AA8DM;EACE,wBAAA;EACA,gBAAA;EACA,uBAAA;AA5DR;AA8DQ;EACE,UAAA;AA5DV;AAiEI;EAEE,UAAA;EACA,mBAAA;AAhEN;AAmEI;EACE,WA5UoB;AA2Q1B;AAmEM;EACE,uBAAA;AAjER;AAmEQ;EACE,aAAA;AAjEV;AAoEQ;EACE,eAAA;AAlEV;AAsEM;EACE,uBAAA;AApER;AAsEQ;EACE,aAAA;AApEV;AA0EE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAxEJ;AA0EI;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EAEA,6BAAA;EACA,YAlXW;EAmXX,gBAAA;EACA,MAAA;EACA,WAAA;AAzEN;AA2EM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAzER;AA2EQ;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAzEV;AA4EQ;EACE,cAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA1EV;AA4EU;EATF;IAUI,eAAA;EAzEV;AACF;AA6EM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA3ER;AA0FQ;EACE,kBAAA;EACA,eAAA;AAxFV;AA0FU;EACE,eAAA;EACA,0BAAA;AAxFZ;AA0FY;EACE,qBAAA;AAxFd;AA4FU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;AA1FZ;AAgGQ;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;AA9FV;AAgGU;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AA9FZ;AAgGY;EACE,yBAAA;AA9Fd;AAiGY;EACE,6BAAA;AA/Fd;AAsGI;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;AApGN;AAsGM;EAPF;IAQI,aAAA;EAnGN;AACF;AAqGM;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AAnGR;AAqGQ;EAPF;IAQI,aAAA;EAlGR;AACF;AAqGM;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AAnGR;AAqGQ;EAPF;IAQI,gBAAA;EAlGR;AACF;AAoGQ;EACE,aAAA;AAlGV;AAsGU;EALF;IAMI,aAAA;EAnGV;AACF;AA2GM;EACE,wBAAA;AAzGR;;AA+GA;EACE;IACE,sBAAA;EA5GF;EA8GE;IAOE,QAAA;EAlHJ;EAoHI;IACE,uBAAA;EAlHN;EAsHE;IACE,WAAA;EApHJ;AACF;AAwHA;EACE;IACE,UAAA;EAtHF;EAwHA;IACE,YAAA;EAtHF;EAwHA;IACE,UAAA;EAtHF;AACF;AA0HA;EAEI;IACE,sBAAA;IACA,QAAA;IACA,YAAA;EAzHJ;EA2HI;IACE,eAAA;IACA,kBAAA;EAzHN;EA4HI;IACE,eAAA;IACA,iBAAA;EA1HN;EA+HA;IACE,sBAAA;IACA,uBAAA;EA7HF;EA+HE;IACE,uBAAA;EA7HJ;AACF","sourcesContent":["$mobile-breakpoint: 768px;\n$sidebar-width: 250px;\n$sidebar-collapsed-width: 60px;\n$top-nav-height: 46px;\n$icon-size-mobile: 18px;\n$icon-size-desktop: 22px;\n\n.dashboard-container {\n  height: 100vh;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n  z-index: auto; \n\n  .trial-warning-banner {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(90deg, #ff6b35, #f7941d);\n    color: white;\n    padding: 12px 20px;\n    z-index: 1000;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    \n    .trial-warning-content {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 12px;\n      max-width: 1200px;\n      margin: 0 auto;\n      \n      .warning-icon {\n        font-size: 16px;\n        animation: pulse 2s infinite;\n      }\n      \n      .warning-text {\n        font-weight: 500;\n        font-size: 14px;\n      }\n      \n      .warning-upgrade-btn {\n        background: white;\n        color: #ff6b35;\n        border: none;\n        padding: 6px 16px;\n        border-radius: 20px;\n        font-weight: 600;\n        font-size: 12px;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        \n        &:hover {\n          background: #f0f0f0;\n          transform: translateY(-1px);\n        }\n      }\n      \n      .warning-close-btn {\n        background: transparent;\n        border: none;\n        color: white;\n        font-size: 18px;\n        font-weight: bold;\n        cursor: pointer;\n        padding: 4px 8px;\n        border-radius: 50%;\n        transition: background 0.3s ease;\n        \n        &:hover {\n          background: rgba(255, 255, 255, 0.2);\n        }\n      }\n    }\n  } \n\n  .mobile-sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 998;\n    display: none;\n\n    @media (max-width: $mobile-breakpoint) {\n      display: block;\n    }\n  }\n\n  .dashboard-sidebar {\n    width: $sidebar-width;\n    background-color: #fff;\n    border-right: 1px solid #ccc;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    transition: width 0.3s ease;\n    position: relative;\n    z-index: 999;\n\n    .sidebar-plan-section {\n      margin-top: auto;\n      position: relative;\n      // padding-top: 10px;\n      overflow: hidden;\n      background: linear-gradient(145deg, #eef1f8, #f7f9fc);\n      // border-top-left-radius: 100% 30%;\n      // border-top-right-radius: 100% 30%;\n      // box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);\n\n      .plan-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 24px 16px;\n        gap: 10px;\n        text-align: center;\n      }\n\n      .plan-heading {\n        font-size: 0.9rem;\n        font-weight: 500;\n        color: #6b7280;\n        letter-spacing: 0.5px;\n      }\n\n      .plan-badge {\n        // background: linear-gradient(135deg, #6366f1, #4f46e5);\n        // background: linear-gradient(135deg, #ff7e5f, #feb47b);\n        // background: linear-gradient(135deg, #4D88FF, var(--primary-color));\n        background-color: #004A9A;\n        color: white;\n        font-size: 0.95rem;\n        padding: 8px 18px;\n        border-radius: 999px;\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 600;\n        box-shadow: 0 4px 10px rgba(99, 102, 241, 0.3);\n\n        .plan-icon {\n          font-size: 1.1rem;\n        }\n      }\n\n      .plan-subtext {\n        font-size: 0.8rem;\n        color: #6b7280;\n        max-width: 140px;\n        line-height: 1.2;\n      }\n\n      .upgrade-button {\n        background: #ff7e5f;\n        background: linear-gradient(to right, #ff7e5f, #feb47b);\n        // background: var(--primary-color);\n        // background: linear-gradient(to right, #4D88FF, var(--primary-color));\n        border: none;\n        padding: 8px 18px;\n        font-size: 0.85rem;\n        color: #fff;\n        border-radius: 8px;\n        cursor: pointer;\n        transition: transform 0.2s ease, box-shadow 0.2s ease;\n        font-weight: 600;\n\n      }\n    }\n\n    .ent-mode {\n      background: transparent;\n    }\n\n    .trial-countdown {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      \n      &.subscription-countdown {\n        background: #f0f4ff;\n        //border-left: 3px solid #4f46e5;\n      }\n      \n      .trial-icon {\n        display: flex;\n        align-items: center;\n      }\n      \n      .trial-info {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n        \n        .trial-text {\n          font-size: 11px;\n          color: #666;\n          font-weight: 500;\n        }\n        \n        .trial-days {\n          font-size: 14px;\n          font-weight: 700;\n          color: #ff6b35;\n          \n          &.urgent {\n            color: #d63031;\n            //animation: pulse 2s infinite;\n          }\n        }\n      }\n      \n      &.subscription-countdown .trial-info .trial-days {\n        color: #4f46e5;\n        \n        &.urgent {\n          color: #d63031;\n          animation: pulse 2s infinite;\n        }\n      }\n    }\n\n\n\n\n    @media (max-width: $mobile-breakpoint) {\n      position: fixed;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      z-index: 999;\n      width: 0;\n      box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n\n\n\n      &.open {\n        width: $sidebar-width !important;\n      }\n\n    }\n\n    .sidebar-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 12px 16px;\n\n      .close-sidebar-btn {\n        background: none;\n        border: none;\n        color: #686868;\n        cursor: pointer;\n        font-size: 1.2rem;\n        display: none;\n\n        @media (max-width: $mobile-breakpoint) {\n          display: block;\n        }\n      }\n    }\n\n    .sidebar-header-closehead {\n      padding: 0px !important;\n    }\n\n    .dashboard-hidden-title {\n      display: none;\n    }\n\n    .dashboard-sidebar-tab {\n      display: flex;\n      align-items: center;\n      padding: 12px 16px;\n      cursor: pointer;\n      white-space: nowrap;\n      overflow: hidden;\n\n      .tab-label-with-badge {\n        display: flex;\n        align-items: center;\n        // justify-content: space-between;\n        // width: 45%;\n        gap: 6px;\n      }\n\n      .count-badge {\n        background-color: crimson;\n        color: #fff;\n        font-size: 10px;\n        padding: 5px;\n        border-radius: 12px;\n        width: 17px;\n        height: 17px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n\n      &:hover,\n      &.active {\n        background-color: #f4f7fe;\n      }\n\n      .dashboard-tab-icon {\n        width: 20px;\n        height: 20px;\n        margin-right: 10px;\n        flex-shrink: 0;\n      }\n\n      span {\n        transition: opacity 0.2s;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        &:not(:empty) {\n          opacity: 1;\n        }\n      }\n    }\n\n    .lawsuitheadtxt {\n      // height: 7vh;\n      width: 90%;\n      object-fit: contain;\n    }\n\n    &.closed:not(.open) {\n      width: $sidebar-collapsed-width;\n\n      .dashboard-sidebar-tab {\n        justify-content: center;\n\n        span {\n          display: none;\n        }\n\n        .dashboard-tab-icon {\n          margin-right: 0;\n        }\n      }\n\n      .sidebar-header {\n        justify-content: center;\n\n        .lawsuitheadtxt {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .dashboard-main-area {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow: hidden;\n\n    .dashboard-top-navbar {\n      background-color: #e2e8f0;\n      color: #262626;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 0 10px;\n      // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n      border-bottom: 2px solid #ddd;\n      height: $top-nav-height;\n      position: sticky;\n      top: 0;\n      z-index: 99;\n\n      .dashboard-top-nav-icons1 {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        .hamburger {\n          font-size: 1.2rem;\n          background: none;\n          border: none;\n          color: #686868;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          padding: 5px;\n        }\n\n        .dashboard-activetabname {\n          color: #262626;\n          margin: 0;\n          font-size: 1rem;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          max-width: 200px;\n\n          @media (min-width: $mobile-breakpoint) {\n            max-width: none;\n          }\n        }\n      }\n\n      .dashboard-top-nav-icons {\n        display: flex;\n        align-items: center;\n        gap: 13px;\n\n        // .dashboard-micon {\n        //   position: relative;\n        //   cursor: pointer;\n\n        //   .dashboard-top-nav-icon-style {\n        //     cursor: pointer;\n        //     transition: transform 0.2s;\n\n        //     &:hover {\n        //       transform: scale(1.1);\n        //     }\n        //   }\n        // }\n        .dashboard-micon {\n          position: relative;\n          cursor: pointer;\n\n          .dashboard-top-nav-icon-style {\n            cursor: pointer;\n            transition: transform 0.2s;\n\n            &:hover {\n              transform: scale(1.1);\n            }\n          }\n\n          .notification-badge {\n            position: absolute;\n            top: -5px;\n            right: -5px;\n            background-color: crimson;\n            color: white;\n            font-size: 10px;\n            padding: 2px 4px;\n            border-radius: 50%;\n            width: 17px;\n            height: 17px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-weight: bold;\n            z-index: 1;\n          }\n\n        }\n\n\n        .dashboard-userstyles {\n          position: absolute;\n          top: calc(100% + 5px);\n          right: 0;\n          width: 150px;\n          background-color: #fff;\n          border-radius: 8px;\n          z-index: 100;\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n          overflow: hidden;\n\n          .dashboard-profiletabs {\n            display: block;\n            text-align: left;\n            width: 100%;\n            padding: 10px 15px;\n            border: none;\n            background: none;\n            cursor: pointer;\n            font-size: 0.9rem;\n            transition: background-color 0.2s;\n\n            &:hover {\n              background-color: #f0f0f0;\n            }\n\n            &:not(:last-child) {\n              border-bottom: 1px solid #eee;\n            }\n          }\n        }\n      }\n    }\n\n    .dashboard-content-area {\n      flex: 1;\n      padding: 15px;\n      overflow-y: auto;\n      background-color: #e2e8f0;\n      height: calc(100vh - #{$top-nav-height});\n\n      @media (max-width: $mobile-breakpoint) {\n        padding: 10px;\n      }\n\n      .main-dashboard-content-area {\n        background-color: #fff;\n        padding: 15px;\n        border-radius: 8px;\n        height: 165px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n\n        @media (max-width: $mobile-breakpoint) {\n          padding: 10px;\n        }\n      }\n\n      .page-content-tabs {\n        background-color: white;\n        margin-top: 15px;\n        border-radius: 8px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n        overflow: hidden;\n\n        @media (max-width: $mobile-breakpoint) {\n          margin-top: 10px;\n        }\n\n        .page-content-component {\n          padding: 20px;\n          // position: relative;\n          // z-index: 1;\n\n          @media (max-width: $mobile-breakpoint) {\n            padding: 15px;\n          }\n\n          &.page-content-componentone {\n            //padding: 0 !important;\n          }\n        }\n      }\n\n      .page-content-tabsone {\n        margin-top: 0 !important;\n      }\n    }\n  }\n}\n\n@media (max-width: $mobile-breakpoint) {\n  .dashboard-container {\n    flex-direction: column;\n\n    .dashboard-sidebar {\n      // .dashboard-sidebar.closed:not(.open) {\n      //   .sidebar-plan-section {\n      //     display: none;\n      //   }\n      // }\n\n      width: 0;\n\n      &.open {\n        width: $sidebar-width !important;\n      }\n    }\n\n    .dashboard-main-area {\n      width: 100%;\n    }\n  }\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n// Mobile responsive styles for trial features\n@media (max-width: $mobile-breakpoint) {\n  .trial-warning-banner {\n    .trial-warning-content {\n      flex-direction: column;\n      gap: 8px;\n      padding: 8px;\n      \n      .warning-text {\n        font-size: 12px;\n        text-align: center;\n      }\n      \n      .warning-upgrade-btn {\n        font-size: 11px;\n        padding: 5px 12px;\n      }\n    }\n  }\n  \n  .sidebar-plan-section .trial-countdown {\n    flex-direction: column;\n    align-items: flex-start;\n    \n    .trial-info {\n      align-items: flex-start;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
